import { fromPairs } from 'lodash';
import { useMemo } from 'react';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useNativeUsersQuery } from 'queries/members';
/**
 * Original hook - fetches all users via /members endpoint and builds metadata.
 * Used by flows that need the full user metadata upfront.
 *
 * @deprecated Consider using useTeamMembersFieldLite for new implementations.
 * The metadata is expensive and filters have fallback mechanisms.
 */ export const useTeamMembersField = (fieldId, peopleIHaveAccessTo)=>{
    const { data: users, isLoading: isUserLoading } = useNativeUsersQuery();
    const fieldLabel = useTranslation('project.fields.team_members');
    return useMemo(()=>({
            teamMemberField: {
                fieldId,
                fieldName: 'teamMembers',
                fieldLabel,
                type: FieldType.MultiUser,
                private: false,
                userCreated: false,
                metaData: {
                    users: {
                        by_user_id: fromPairs((users !== null && users !== void 0 ? users : []).map((x)=>[
                                x.userId,
                                x
                            ])),
                        active_user_ids: (users !== null && users !== void 0 ? users : []).map((x)=>x.userId),
                        non_external_user_ids: (users !== null && users !== void 0 ? users : []).map((x)=>x.userId).filter((x)=>peopleIHaveAccessTo ? peopleIHaveAccessTo[x] : true),
                        by_project_id: {}
                    },
                    required: true
                },
                sourceType: SourceType.Project
            },
            isLoading: isUserLoading
        }), [
        fieldId,
        fieldLabel,
        isUserLoading,
        peopleIHaveAccessTo,
        users
    ]);
};
/**
 * Lightweight version - no API calls, no metadata.
 * Uses fallback mechanisms in filters (useFilterUserOptions) to fetch users.
 * Filters will call useGetAllMembersInProject({ projectId }) → /projects/{id}/members
 *
 * Use this for:
 * - Grid views with projectId context (project list, etc.)
 * - Any flow where filters can fetch users on-demand
 */ export const useTeamMembersFieldLite = (fieldId)=>{
    const fieldLabel = useTranslation('project.fields.team_members');
    return useMemo(()=>({
            teamMemberField: {
                fieldId,
                fieldName: 'teamMembers',
                fieldLabel,
                type: FieldType.MultiUser,
                private: false,
                userCreated: false,
                metaData: {
                    users: {
                        by_user_id: {},
                        active_user_ids: [],
                        non_external_user_ids: [],
                        by_project_id: {}
                    },
                    required: true
                },
                sourceType: SourceType.Project
            },
            isLoading: false
        }), [
        fieldId,
        fieldLabel
    ]);
};
